import { ApiPostPhone } from './../Types/UserPhone/Api';
import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import { ApiResult, ApiUserPhoneCreate, ApiUserPhoneRequest, ApiUserPhoneCheck, ApiUserPhoneResult } from 'Types'

const endpoint = `${apiUrl.stable}/cliente/telefonemovel`

export const getPhone = (ddd: string, number: string): ApiResult<ApiUserPhoneResult> => {
  const url = `${endpoint}/obtem`

  const headers = { ...jsonWebToken.header }

  const params: ApiUserPhoneRequest = {
    CountryCodeArea: '55',
    LocalCodeArea: ddd,
    MobilePhoneNumber: number,
  }

  return axios.get(url, { headers })
}

export const getPhoneList = (): ApiResult<ApiUserPhoneResult[]> => {
  const url = `${endpoint}/lista`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const addPhone = (ddd: string, number: string, typeReceivementValue: number): ApiResult<{ token: string }> => {
  const url = `${endpoint}/cadastra`

  const headers = { ...jsonWebToken.header }

  const data: ApiUserPhoneCreate = {
    countryCodeArea: '55',
    localCodeArea: ddd,
    mobilePhoneNumber: number.replace('-', ''),
    typeReceivement: typeReceivementValue,
  }

  return axios.put(url, data, { headers })
}

export const removePhone = (phoneId: number): ApiResult<any> => {
  const url = `${endpoint}/exclui`

  const headers = { ...jsonWebToken.header }

  const data = {
    mobilePhoneId: phoneId
  }

  return axios.put(url, data, { headers })
}

export const checkPhone = (data: ApiUserPhoneCheck): ApiResult<any> => {
  const url = `${endpoint}/valida`

  const headers = { ...jsonWebToken.header }

  return axios.put(url, data, { headers })
}

export const refreshPhoneToken = (ddd: string, number: string, typeReceivementValue: number): ApiResult<{ token: string }> => {
  const url = `${endpoint}/reenvia`

  const headers = { ...jsonWebToken.header }

  const data: ApiUserPhoneCreate = {
    countryCodeArea: '55',
    localCodeArea: ddd,
    mobilePhoneNumber: number.replace('-', ''),
    typeReceivement: typeReceivementValue,
  }

  return axios.put(url, data, { headers })
}

export default {
  getPhone
}